/*
 * Experiences Messages
 *
 * This contains all the text for the Experiences component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.containers.Experiences.header',
    defaultMessage: 'Experiences',
  },
  noExperiences: {
    id: 'app.containers.Experiences.noExperiences',
    defaultMessage: 'You have not submitted any experiences yet.',
  },
  newHeader: {
    id: 'app.containers.Experiences.newHeader',
    defaultMessage: 'New Experience',
  },
  createEventHeader: {
    id: 'app.containers.Experiences.createEventHeader',
    defaultMessage: 'Add Event',
  },
  editExperienceTitleTooltip: {
    id: 'app.containers.Experiences.editExperienceTitleTooltip',
    defaultMessage: 'Edit Experience Title',
  },
  editEventHeader: {
    id: 'app.containers.Experiences.editEventHeader',
    defaultMessage: 'Edit Event',
  },
  editExperienceTitleHeader: {
    id: 'app.containers.Experiences.editExperienceTitleHeader',
    defaultMessage: 'Edit Experience Title',
  },
  detailsHeader: {
    id: 'app.containers.Experiences.detailsHeader',
    defaultMessage: 'Experience Details',
  },
  saveButton: {
    id: 'app.containers.Experiences.saveButton',
    defaultMessage: 'Save Experience',
  },
  saveEventButton: {
    id: 'app.containers.Experiences.saveEventButton',
    defaultMessage: 'Save Event',
  },
  positiveLabel: {
    id: 'app.containers.Experiences.positiveLabel',
    defaultMessage: 'Type of this experience',
  },
  positive: {
    id: 'app.containers.Experiences.positive',
    defaultMessage: 'Positive',
  },
  negative: {
    id: 'app.containers.Experiences.negative',
    defaultMessage: 'Negative',
  },
  selectTurnLabel: {
    id: 'app.containers.Experiences.selectTurnLabel',
    defaultMessage: 'Happened in this shift',
  },
  inNoShift: {
    id: 'app.containers.Experiences.inNoShift',
    defaultMessage: 'It happend outside of my recent shifts',
  },
  eventDateLabel: {
    id: 'app.containers.Experiences.eventDateLabel',
    defaultMessage: 'Date the experience happened',
  },
  eventTimeLabel: {
    id: 'app.containers.Experiences.eventTimeLabel',
    defaultMessage: 'Time the experience happened',
  },
  locationLabel: {
    id: 'app.containers.Experiences.locationLabel',
    defaultMessage: 'Location the experience took place at',
  },
  required: {
    id: 'app.containers.Experiences.required',
    defaultMessage: 'Hint that a field is required',
  },
  titleLabel: {
    id: 'app.containers.Experiences.titleLabel',
    defaultMessage: 'Title of the experience or short description',
  },
  descriptionLabel: {
    id: 'app.containers.Experiences.descriptionLabel',
    defaultMessage: 'Description of what happened',
  },
  createExperienceFailure: {
    id: 'app.containers.Experiences.createExperienceFailure',
    defaultMessage: 'Error while saving the experience, please try again.',
  },
  createExperienceSuccess: {
    id: 'app.containers.Experiences.createExperienceSuccess',
    defaultMessage: 'New experience successfully saved.',
  },
  createEventFailure: {
    id: 'app.containers.Experiences.createEventFailure',
    defaultMessage: 'Error while saving the event, please try again.',
  },
  createEventSuccess: {
    id: 'app.containers.Experiences.createEventSuccess',
    defaultMessage: 'New event successfully saved.',
  },
  editEventFailure: {
    id: 'app.containers.Experiences.editEventFailure',
    defaultMessage: 'Error while saving the event, please try again.',
  },
  editEventSuccess: {
    id: 'app.containers.Experiences.editEventSuccess',
    defaultMessage: 'Event successfully saved.',
  },
  editExperienceTitleFailure: {
    id: 'app.containers.Experiences.editExperienceTitleFailure',
    defaultMessage: 'Error while saving the title, please try again.',
  },
  editExperienceTitleSuccess: {
    id: 'app.containers.Experiences.editExperienceTitleSuccess',
    defaultMessage: 'Title successfully saved.',
  },
  outsideOfShift: {
    id: 'app.containers.Experiences.outsideOfShift',
    defaultMessage: 'It happened outside of any shift',
  },
  generalSection: {
    id: 'app.containers.Experiences.generalSection',
    defaultMessage: 'General',
  },
  eventsSection: {
    id: 'app.containers.Experiences.eventsSection',
    defaultMessage: 'Events',
  },
  back: {
    id: 'app.containers.Experiences.back',
    defaultMessage: 'Back',
  },
});
